import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const TabGroupEnd = styled.div`
  margin-inline-start: auto;
`

export const TabGroup = styled.div`
  display: flex;
  flex-direction: row;
  grid-gap: 0.5em;
  margin-block-end: 2em;
  align-items: center;
  inline-size: 100%;

  > :not(${TabGroupEnd}):not(:first-child) {
    /* Not really a good practice to set 'display' on the children, but it works best for now. */
    display: flex;
    flex-direction: row;

    ::before {
      content: '';
      border-inline-start: ${theme.borders.tabGroup};
      padding-inline-start: 0.7em;
      margin: 0.3em 0;
    }
  }
`
